/**
 * route-link.js
 */

import React from 'react';
import { Link } from '@mui/material';
import { useLocation, Link as RouterLink } from "react-router-dom";
import { makeLocation } from 'utils/routing';


export default React.forwardRef(function RouteLink(props, ref) {
  const {
    basePath,
    pathSectionName,
    pathItemName,
    pathParams,
    queryParams,
    isTextLink,
    ...rest
  } = props;
  const location = useLocation();

  const to = makeLocation(
    basePath,
    pathSectionName,
    pathItemName,
    pathParams,
    location,
    queryParams
  );

  return isTextLink
    ? <Link
    component={RouterLink}
    ref={ref}
    to={to}
    children=''
    {...rest}
    underline="hover" />
    : <RouterLink
      ref={ref}
      to={to}
      children=''
      {...rest}
    />;
});